import { useAdvancedFormContext } from "../advanced-form";
import styled from "styled-components";
import TextArea from "antd/es/input/TextArea";

export const TextAreaStyled = styled(TextArea)`
  &[readonly] {
    background: none;
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }
`

function FormItemText({readOnly, disabled, label, value, onChange}: any) {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <TextAreaStyled value={value} onChange={onChange} readOnly={readOnly || advancedFormContext?.readOnly} disabled={disabled} placeholder={label} rows={4} />
  )
}

export default FormItemText;